import React from 'react';

export function StatusIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="1em" height="1em" {...props}>
            <path
                fill="currentColor"
                d="M33.818 7.818a4.5 4.5 0 0 1 6.364 6.364l-12.35 12.35a1.75 1.75 0 0 1-.808.459l-8.049 2.034l2.034-8.049a1.75 1.75 0 0 1 .46-.809zM41.95 6.05a7 7 0 0 0-9.9 0L19.7 18.4a4.25 4.25 0 0 0-1.114 1.963l-2.548 10.08a1.25 1.25 0 0 0 1.518 1.519l10.08-2.547a4.25 4.25 0 0 0 1.964-1.116l12.35-12.35a7 7 0 0 0 0-9.899M26.56 8.71A15.6 15.6 0 0 0 24 8.5C15.44 8.5 8.5 15.44 8.5 24S15.44 39.5 24 39.5S39.5 32.56 39.5 24q-.002-1.31-.21-2.561l2.1-2.102c.398 1.488.61 3.05.61 4.663c0 9.941-8.059 18-18 18S6 33.941 6 24S14.059 6 24 6c1.612 0 3.175.212 4.662.61z"></path>
        </svg>
    );
}
